import { createAction, handleActions } from 'redux-actions'

const setSubOrders = createAction('SCREENS/SUBBIES/SUB_ORDERS/SET_SUB_ORDERS')
const resetSubOrders = createAction('SCREENS/SUBBIES/SUB_ORDERS/RESET_SUB_ORDERS')

const defaultState = []

const reducer = handleActions(
  {
    [setSubOrders]: (state, { payload }) => payload,
    [resetSubOrders]: () => [],
  },
  defaultState,
)

export { setSubOrders, resetSubOrders, reducer }
